export default "__VITE_ASSET__qL1WXNY5__"